import React from 'react';
import { Cpu, ShieldCheck, Mail, Lock, ArrowRight } from 'lucide-react';

export default function LoginView({
  email,
  setEmail,
  password,
  setPassword,
  authError,
  loading,
  onLogin,
}) {
  return (
    <div className="auth-container">
      <div className="auth-card">
        {/* Brand Header */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div
            style={{
              width: '56px',
              height: '56px',
              borderRadius: '16px',
              background: 'linear-gradient(135deg, rgba(0, 240, 255, 0.2), rgba(168, 85, 247, 0.2))',
              border: '1px solid rgba(0, 240, 255, 0.4)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px auto',
              boxShadow: '0 0 25px rgba(0, 240, 255, 0.3)',
            }}
          >
            <Cpu size={30} style={{ color: 'var(--neon-cyan)' }} />
          </div>
          <h1 style={{ fontSize: '1.75rem', fontWeight: 900, color: 'var(--text-primary)', letterSpacing: '0.04em', margin: 0 }}>
            LOKA <span style={{ color: 'var(--neon-cyan)' }}>CONSOLE</span>
          </h1>
          <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginTop: '6px', fontWeight: 600 }}>
            CYBER ADMIN MANAGEMENT PORTAL
          </p>
        </div>

        {/* Error Alert */}
        {authError && (
          <div
            style={{
              padding: '12px 16px',
              borderRadius: '10px',
              background: 'rgba(244, 63, 94, 0.15)',
              border: '1px solid rgba(244, 63, 94, 0.3)',
              color: 'var(--neon-rose)',
              fontSize: '0.82rem',
              fontWeight: 700,
              marginBottom: '20px',
              textAlign: 'center',
            }}
          >
            {authError}
          </div>
        )}

        {/* Login Form */}
        <form onSubmit={onLogin}>
          <div className="form-group">
            <label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Mail size={14} style={{ color: 'var(--neon-cyan)' }} /> Admin Email Address
            </label>
            <input
              type="email"
              className="form-control"
              placeholder="admin@rapmap.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Lock size={14} style={{ color: 'var(--neon-purple)' }} /> Master Key Password
            </label>
            <input
              type="password"
              className="form-control"
              placeholder="••••••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-cyan"
            disabled={loading}
            style={{ width: '100%', padding: '13px', marginTop: '12px', fontSize: '0.95rem', borderRadius: '12px' }}
          >
            {loading ? <span className="spinner" /> : <>AUTHENTICATE & LOG IN <ArrowRight size={18} /></>}
          </button>
        </form>

        <div style={{ marginTop: '24px', textAlign: 'center', fontSize: '0.72rem', color: 'var(--text-muted)' }}>
          <ShieldCheck size={14} style={{ display: 'inline', marginRight: '4px', verticalAlign: 'middle', color: 'var(--neon-emerald)' }} />
          Encrypted 256-Bit SSL Admin Terminal
        </div>
      </div>
    </div>
  );
}
